<template>
  <div class="background-login">
    <div class="auth-content animate__animated animate__fadeInDown">
      <b-form class="auth-modal" @submit="signin" @reset="onReset">
        <img src="@/assets/logo_base.png" class="mt-0" alt="Logo" />
        <hr />
        <b-form-group
          class="form-group"
          style="width: 100%"
          id="input-group-1"
          label="Usuário:"
          label-for="input-1"
        >
          <div class="group-input">
            <b-form-input
              class="input"
              style="width: 100%"
              id="input-1"
              v-model="user.login"
              type="text"
              required
            ></b-form-input>
            <span>
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="user"
                class="svg-inline--fa fa-user fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                ></path>
              </svg>
            </span>
            <!-- <i class="fa fa-user"></i> -->
          </div>
        </b-form-group>
        <b-form-group
          style="width: 100%"
          id="input-group-2"
          label="Senha:"
          label-for="input-1"
        >
          <div class="group-input">
            <b-form-input
              class="input"
              style="width: 100%"
              id="input-2"
              v-model="user.senha"
              :type="isPassword ? 'text' : 'password'"
              required
            ></b-form-input>

            <div class="eye" v-on:click="handleIsPassword">
              <i v-if="isPassword" class="fa fa-eye"></i>
              <i v-else class="fa fa-eye-slash"></i>
            </div>
            <!-- <i class="fa fa-lock"></i> -->
            </div>
        </b-form-group>
        <b-button type="submit">Entrar</b-button>
        <hr style="width: 100%; margin-top: 20px" />
        <small>Versão {{ version }}</small>
      </b-form>
    </div>
  </div>
</template>

<script>
import packageJson from "../../../package.json";
import { mapState } from "vuex";
import { baseApiUrl, showError, userKey } from "@/global";
import axios from "axios";

export default {
  name: "Auth",
  data: function () {
    return {
      user: {},
      isPassword: false,
    };
  },
  computed: {
    ...mapState(["isLogin"]),
    version() {
      return packageJson.version;
    },
  },
  methods: {
    signin(event) {
      event.preventDefault();
      axios
        .post(`${baseApiUrl}/api/autenticacao`, this.user)
        .then((res) => {
          sessionStorage.setItem("loginPassword", JSON.stringify(this.user));
          this.$store.commit("setUser", res.data);
          sessionStorage.setItem(userKey, JSON.stringify(res.data));
          this.$router.push({ path: "/" });
        })
        .catch((res) => showError(res));
    },
    handleIsPassword() {
      this.isPassword = !this.isPassword;
    },
    onReset(event) {
      event.preventDefault();
      this.use = {};
    },
  },
  mounted() {
    this.$store.commit("toggleMenu", false);
    this.$store.commit("toggleFooter", false);
  },
};
</script>

<style>

.eye {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 20%;
  height: 38px;
  background-color: #fff;
  font-size: large;
}

.background-login {
  background: url("../../assets/novo_fundo.png");
  height: 100%;
  width: 100%;
  background-size: cover;
}

.auth-content {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth-modal {
  margin: 20px;
  border-radius: 5px;
  color: #fff;
  background-color: #333333;
  width: 300px;
  padding: 30px 20px 15px;
  /* box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15); */

  display: flex;
  flex-direction: column;
  align-items: center;
}

.form-group {
  font-size: 0.8rem;
}

.group-input {
  display: flex;
  align-items: center;
}

.group-input i {
  box-sizing: border-box;
  padding: 2px;
  background-color: #fff;
  border-left: none;
  color: #414345;
}

.group-input .input {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.group-input span {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 38px;
  border: solid 1px #ced4da;
  padding: 7px 12px;
  background-color: #fff;
}

.group-input span > svg {
  font-size: 1rem;
  color: #414345;
}

.auth-modal button {
  border: none;
  width: 100%;
  background-color: #FFB300;
  color: #000;
}

.auth-modal button:hover {
  background: rgba(255, 193, 7, 0.8);
  color: #000;
}
</style>